exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".countdown {\n  text-align: center;\n  font-size: 0.24rem;\n  line-height: 0.48rem;\n  color: #fff;\n  width: 5.06rem;\n  height: 0.48rem;\n  background: url('/img/activity/pk/cd.png') no-repeat;\n  background-size: 100% 100%;\n  position: absolute;\n  top: 0.75rem;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.countdown div {\n  display: inline-block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/pkactivity/Countdown/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/pkactivity/Countdown/index.less
// module chunks = 0